import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Stepper, Step, StepLabel } from "@material-ui/core";

import { Icon, Button, Level } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ourToast as toast } from "../../utils";

import "./Steps.scss";

const Steps = ({ steps, onCancel, defaultStep, numberError }) => {
  const currentSection = useRef(null);
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    setCurrentStep(defaultStep);
  }, [defaultStep]);

  const onClickPrev = (step = defaultStep) => {
    if (steps[step - 1].disabled) {
      onClickPrev(step - 1);
    } else {
      setCurrentStep(step - 1);
    }
  };
  const onClickNext = (step = currentStep) => {
    const requiredFields = [
      ...currentSection.current.querySelectorAll("input[required]")
    ].filter(field => !field.validity.valid);

    const requiredSelectFields = [
      ...currentSection.current.querySelectorAll("select[required]")
    ].filter(
      field => field.value === "0" && field.name === "VehicleTypeRecIdRef"
    );
    if (!requiredFields.length && !requiredSelectFields.length) {
      if (steps[step + 1].disabled) {
        onClickNext(step + 1);
      } else {
        setCurrentStep(step + 1);
      }
    } else {
      let messages = requiredFields.map(
        field => `${field.name} - ${field.validationMessage}`
      );
      messages = [
        ...messages,
        ...requiredSelectFields.map(field =>
          field.name === "VehicleTypeRecIdRef"
            ? "Vehicle Type is required"
            : `${field.name} - ${field.validationMessage}`
        )
      ];
      messages.forEach(message => toast.warning(message));
    }
  };
  return (
    <React.Fragment>
      <Stepper
        alternativeLabel
        activeStep={currentStep}
        style={{ background: "none", margin: "0px" }}
      >
        {steps.map(({ title }) => (
          <Step key={title}>
            <StepLabel>{title}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div className="steps-content" key={currentStep} ref={currentSection}>
        {steps[currentStep].content}
      </div>
      <hr />
      <div className="steps-controls">
        <Level>
          <Level.Item align="left">
            <Button.Group>
              <Button
                disabled={currentStep === 0}
                type="button"
                onClick={() => onClickPrev(currentStep)}
              >
                <Icon>
                  <FontAwesomeIcon icon="arrow-left" />
                </Icon>
                <span>Back</span>
              </Button>
              {onCancel && (
                <Button color="danger" type="button" onClick={onCancel}>
                  Cancel
                </Button>
              )}
            </Button.Group>
          </Level.Item>
          <Level.Item align="right">
            <Button
              disabled={currentStep === steps.length - 1 || numberError}
              type="button"
              onClick={() => onClickNext(currentStep)}
            >
              <span>Next</span>
              <Icon>
                <FontAwesomeIcon icon="arrow-right" />
              </Icon>
            </Button>
          </Level.Item>
        </Level>
      </div>
    </React.Fragment>
  );
};

Steps.propTypes = {
  steps: PropTypes.array,
  defaultStep: PropTypes.number,
  onCancel: PropTypes.func,
  numberError: PropTypes.bool
};
export default Steps;
